/**
 * Escape de HTML para texto que se inyecta con `innerHTML`.
 *
 * SweetAlert2 arma sus popups con la opcion `html`, asi que todo lo que se interpola
 * ahi se ejecuta como markup. Varios de esos mensajes vienen del backend (por ejemplo
 * el detalle orden por orden de un lote de envios Flex): si alguno trae markup, se
 * ejecuta en el navegador del operador.
 */
export const escapeHtml = (value) => {
  if (value === null || value === undefined) return "";

  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
};
